module.exports = __webpack_public_path__ + "img/nina.bbc3d3b5.jpg";